import React from 'react';
import { NavItem, NavigationItemProps } from './item';

export const NavMenu: React.FC<{ items: NavigationItemProps[] }> = ({
	items,
	
}) => {
	return (
		<nav className="flex items-center divide-x-2 divide-font-menu md:divide-opacity-30 print:hidden">
			{items.map((menu, index) => (
				<NavItem key={index} {...menu} />
			))}
		</nav>
	);
};
